import { Tooltip } from "@mui/material";
import Icon, { ICONS } from "./Icons";
import React from "react";

interface Props {
  text: string;
  placement?: any;
}

const InfoTooltip: React.FC<Props> = React.memo((props) => {
  return (
    <Tooltip
      title={props.text}
      arrow
      placement={props.placement || "top"}
      PopperProps={{ style: { zIndex: 1000000 } }}
    >
      <button
        className="tooltip-button"
        style={{
          fontSize: "revert",
        }}
      >
        <Icon
          icon={ICONS.INFO}
          style={{
            width: 15,
            height: 15,
          }}
        />
      </button>
    </Tooltip>
  );
});

export default InfoTooltip;
